let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5d33P")).then(() => parcelRequire('cSOv3'));